// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__dsDZM","modalContent":"Modal_modalContent__Wd1sl","close":"Modal_close__TLjkq","image":"Modal_image__XACae"};